import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";
import './FinalidadeSolicitacaoAdesao.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { ModalIntrucoesPreenchimentoFinalidade } from "../ModalInstrucoesPreenchimentoFinalidade/ModalInstrucoesPreenchimentoFinalidade";

const mapDispatchToProps = { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

export const FinalidadeSolicitacaoAdesao =

withRouter(

// redux
connect(
	(null), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.state = {
				textoPadraoFinalidade: '',
				exibeModalModeloFinalidade: false,
				exibeModalInstrucao: false,
			};
			
			this.handleInputChange = this.handleInputChange.bind(this);
			this.carregarTextoPadraoFinalidade = this.carregarTextoPadraoFinalidade.bind(this);
            this.copiaModeloFinalidade = this.copiaModeloFinalidade.bind(this);
			this.fechaModal = this.fechaModal.bind(this);
		}

		render() {
			return (
	            <div className="div-form">
                    {this.renderForm()}
                </div>
			);
		}

		componentDidMount(){
    		this.carregarTextoPadraoFinalidade();
		}

		renderForm() {
			const { textoPadraoFinalidade } = this.state;

			return(
				<>

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalModeloFinalidade}
						handleOk={() => this.copiaModeloFinalidade()}
						handleCancel={() => this.fechaModal()}
						okText='Sim'
						cancelText='Não'
						width='600'
						message={"Esse é o conteúdo que deve ser contemplado no texto da finalidade. Deseja copiá-lo?"}>
							
							<div className="br-form">
								<div className="row">
									<div className="col">
										<div className="field">
											<div className="input">
												<textarea value={textoPadraoFinalidade} className="textarea-texto-padro-finalidade" readOnly/>
											</div>
										</div>
									</div>
								</div>
							</div>

					</ConfirmModal>

					<ModalIntrucoesPreenchimentoFinalidade
						titulo="Instruções para preenchimento do campo finalidade" 
						visible={this.state.exibeModalInstrucao}
						handleClose={() => this.setState({exibeModalInstrucao: false})}
					/>

					<div className="br-form">
                        <div className="row">
                            <div className="col-md">  
                                <div className="field">
                                    <div className="input"> 
                                        <label htmlFor="finalidade">
                                            Finalidade:
                                            <button type="button" className="ajuda-button" title="Exibe texto padrão para o preenchimento do campo finalidade" onClick={() => this.setState({exibeModalModeloFinalidade: true})}>
                                                <span className="sr-only">Exibe texto padrão para preenchimento do campo finalidade</span>
                                                <FontAwesomeIcon icon={faMagnifyingGlass} style={{color: "#1351b4"}} />
                                            </button>

                                            <button type="button" className="ajuda-button" title="Exibe instruções para o preenchimento do campo finalidade" onClick={() => this.setState({exibeModalInstrucao: true})}>
                                                <span className="sr-only">Exibe instruções para preenchimento do campo finalidade</span>
                                                <i className="fas fa-question"></i>
                                            </button>
                                        </label>
                                        <textarea name="finalidade" value={this.props.solicitacao.finalidade} onChange={this.handleInputChange} maxLength={3000} style={{height:"300px"}}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
				
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;

			const { onChangeProperties } = this.props;
			if (onChangeProperties) {
				onChangeProperties(nome, valor);
			}
		}

		carregarTextoPadraoFinalidade() {
			api.get('/api/solicitacao-adesao-arquivo-gv/texto-padrao-finalidade')
				.then(response => { 
					this.setState({textoPadraoFinalidade: response.data['textoPadraoFinalidade'] }) 
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível recuperar o texto padrão de finalidade.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
				}).finally(() => {
					this.setState({carregandoResponsaveisTecnicos : false});
				});
		}
		
		copiaModeloFinalidade() {
			const { textoPadraoFinalidade} = this.state;
            const { onChangeProperties } = this.props;
			if (onChangeProperties) {
				onChangeProperties('finalidade', textoPadraoFinalidade);
			}
			this.fechaModal();
		}

		fechaModal () {
			this.setState(
				{
					exibeModalModeloFinalidade: false,
				}
			);
		}
	
	}

) // redux
); // router